import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { AppContext } from '@state/context'
import { removeToast } from '@state/actions/toastsAction'
import Button from '@components/Button'

const Toast = (props) => {
  const { children, id, error = false } = props

  const [, dispatch] = useContext(AppContext)

  const classes = classNames(
    'py-3 pl-5 pr-12 mt-1 rounded-[4px] max-w-[280px] shadow-lg relative text-black',
    {
      'bg-[#DDFAD9]': !error,
      'bg-[#E9C3C3]': error,
    }
  )

  return (
    <div className={classes}>
      <div className={'flex items-start'}>
        <p>{children}</p>
        <Button
          icon={'CloseMedium'}
          classes={'absolute top-[7px] right-[3px]'}
          handleClick={() => {
            dispatch(removeToast(id))
          }}
        />
      </div>
    </div>
  )
}

Toast.propTypes = {
  id: PropTypes.string,
  text: PropTypes.string,
}

export default Toast
